module.exports = __webpack_public_path__ + "static/media/ic_choose_from_computer.128f1768.svg";